import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFunctionaryTypesAction } from "../actions";
import { getLoading, getData, getTypes, getRequires } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";

const FunctionaryTypesSettings = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const types = useSelector(getTypes);
    const requires = useSelector(getRequires);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getFunctionaryTypesAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.organizationalDefinitions);
    };

    return (
        <ABMLayout
            title={getLocalizedString("functionaryTypesSettings")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newFunctionaryType")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noFunctionaryTypes")}
            noDataCreateTitle={getLocalizedString("newFunctionaryType")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem
                        color={color}
                        data={null}
                        types={types}
                        requires={requires}
                        closeNew={() => setCreateIsOpen(false)}
                    />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.internalCode}>
                            <DataItem data={item} types={types} requires={requires} color={color} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default FunctionaryTypesSettings;
